const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m94 144h20v20c0 8.284 6.716 15 15 15s15-6.716 15-15v-20h20c8.284 0 15-6.716 15-15s-6.716-15-15-15h-20v-20c0-8.284-6.716-15-15-15s-15 6.716-15 15v20h-20c-8.284 0-15 6.716-15 15s6.716 15 15 15z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327 144h60c8.284 0 15-6.716 15-15s-6.716-15-15-15h-60c-8.284 0-15 6.716-15 15s6.716 15 15 15z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392 367h-70c-8.284 0-15 6.716-15 15s6.716 15 15 15h70c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392 317h-70c-8.284 0-15 6.716-15 15s6.716 15 15 15h70c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.606 321.394c-5.857-5.858-15.355-5.858-21.213 0l-14.393 14.393-14.394-14.394c-5.857-5.858-15.355-5.858-21.213 0s-5.858 15.355 0 21.213l14.394 14.394-14.394 14.394c-5.858 5.858-5.858 15.355 0 21.213 2.929 2.929 6.768 4.393 10.607 4.393s7.678-1.464 10.606-4.394l14.394-14.393 14.394 14.394c2.928 2.929 6.767 4.393 10.606 4.393s7.678-1.464 10.606-4.394c5.858-5.858 5.858-15.355 0-21.213l-14.393-14.393 14.394-14.394c5.858-5.857 5.858-15.355-.001-21.212z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486 271.169v-226.169c0-24.813-20.187-45-45-45h-396c-24.813 0-45 20.187-45 45v396c0 24.813 20.187 45 45 45h226.168c24.59 16.416 54.111 26 85.832 26 85.468 0 155-69.533 155-155 0-31.72-9.584-61.241-26-85.831zm-30-226.169v192.83c-26.871-22.361-61.391-35.83-99-35.83s-72.129 13.469-99 35.83v-207.83h183c8.271 0 15 6.729 15 15zm-411-15h183v198h-198v-183c0-8.271 6.729-15 15-15zm-15 411v-183h198v13.169c-16.416 24.59-26 54.111-26 85.831 0 37.609 13.469 72.129 35.83 99h-192.83c-8.271 0-15-6.729-15-15zm327 41c-68.925 0-125-56.075-125-125s56.075-125 125-125 125 56.075 125 125-56.075 125-125 125z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCal);
export default __webpack_public_path__ + "static/media/cal.b0ea6f8bd5e8a50a22a28799343bbb58.svg";
export { ForwardRef as ReactComponent };